import { render, staticRenderFns } from "./CounterValue.vue?vue&type=template&id=6993b931"
import script from "./CounterValue.ts?vue&type=script&lang=ts&external"
export * from "./CounterValue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports